import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function resendLicenseEmail(id: number) {
  return requests.post(`${LicenseEndpoints.LICENSE}/${id}/send`, {})
}

export default resendLicenseEmail
